export const ENROLL_STATES = {
  NO_EXISTING_USER: '',
  EXISTING_FACEBOOK_USER: 'facebook',
  EXISTING_USER: 'existing',
  RESET_PASSWORD: 'reset',
}

export const FIRE_EMAIL_CAPTURED = 'fire_email_captured'

export const AUTH_TYPE = {
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  EMAIL: 'email',
}
